import React from 'react'
import { Outlet } from 'react-router-dom'

const DepositComponent = () => {
  return (
    <div>
        <Outlet/>
    </div>
  )
}

export default DepositComponent
